module.exports = __webpack_public_path__ + "static/media/note8.4c3ac83a.wav";